module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button-primary', {
    staticClass: "pull-right",
    attrs: {
      "label": _vm.$t('modalLogAuditoria.imprimir'),
      "id": "btnImprimirDetalhes",
      "clickFunction": _vm.print
    }
  })
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2b0b37d6", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2b0b37d6"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/buttons/buttonPrint/buttonPrint.pug
// module id = 1386
// module chunks = 0